import React, { FC, PropsWithChildren } from "react";
import clsx from "clsx";

import { Listbox } from "@headlessui/react";
import { ArrowIos } from "src/shared/ui";

import type { SelectProps, OptionProps } from "./index.d";

export function Select({
  value,
  onChange,
  label,
  children,
  data,
  labelCn,
  buttonCn,
  optionsCn,
}: SelectProps) {
  return (
    <Listbox value={value} onChange={onChange}>
      {label && (
        <Listbox.Label
          className={clsx("text-label-xs text-low-contrast", labelCn)}
        >
          {label}
        </Listbox.Label>
      )}
      <Listbox.Button
        className={({ open }) =>
          clsx(
            "w-full pb-1 flex text-high-contrast items-start relative border-b duration-300 leading-5.25 text-sm h-[21px]",
            {
              "border-neutral-5": !open,
              "border-primary-light": open,
            },
            buttonCn
          )
        }
      >
        {({ open }) => (
          <>
            {value?.name || "Не обрано"}
            <span className="absolute right-0 top-0">
              <ArrowIos
                className={clsx("transform duration-150 w-4 h-4", {
                  "rotate-90": open,
                  "rotate-270": !open,
                })}
              />
            </span>
          </>
        )}
      </Listbox.Button>

      <Listbox.Options
        className={clsx(
          "z-[1100] rounded border border-neutral-5 bg-white py-2 absolute mt-1 max-h-[300px] w-full overflow-y-auto",
          optionsCn
        )}
      >
        {children({ data })}
      </Listbox.Options>
    </Listbox>
  );
}

export const Option: FC<PropsWithChildren<OptionProps>> = ({
  value,
  className,
  children,
}) => (
  <Listbox.Option
    className={({ active }) =>
      clsx(
        "h-10 px-4 flex items-center duration-150 cursor-pointer",
        {
          "bg-hover-gray": active,
        },
        className
      )
    }
    value={value}
  >
    {children}
  </Listbox.Option>
);
